// Equilibradamente — Landing Page
import HeroSection from './components/HeroSection';
import EmotionalIdentification from './components/EmotionalIdentification';
import NervousSystemSection from './components/NervousSystemSection';
import WhatHappensSection from './components/WhatHappensSection';
import ExperienceSimulation from './components/ExperienceSimulation';
import PossibleBenefits from './components/PossibleBenefits';
import VideoTestimonials from './components/VideoTestimonials';
import FounderBio from './components/FounderBio';
import UnifiedFirstStep from './components/UnifiedFirstStep';
import FinalCTA from './components/FinalCTA';
import TransparencySection from './components/TransparencySection';
import LandingFooter from './components/LandingFooter';
import TopNavBar from './components/TopNavBar';
import FloatingCTA from './components/FloatingCTA';

export default function HomePage() {
  return (
    <main style={{ fontFamily: "'DM Sans', sans-serif" }}>
      {/* Top Navigation with Logo */}
      <TopNavBar />

      {/* Section 1 — Hero */}
      <HeroSection />

      {/* Section 2 — Emotional Identification */}
      <EmotionalIdentification />

      {/* Section 3 — Nervous System Explanation */}
      <NervousSystemSection />

      {/* Section 4 — What Happens in the Session */}
      <WhatHappensSection />

      {/* Section 5 — Experience Simulation */}
      <ExperienceSimulation />

      {/* Section 6 — Possible Benefits */}
      <PossibleBenefits />

      {/* Depoimentos em vídeo */}
      <VideoTestimonials />

      {/* Quem conduz essa experiência — Bio do Reginaldo */}
      <FounderBio />

      {/* Seção unificada — Primeiro passo + Etapas + Preparação */}
      <UnifiedFirstStep />

      {/* Section — Final CTA */}
      <FinalCTA />

      {/* Section — Transparency */}
      <TransparencySection />

      {/* Section — Footer */}
      <LandingFooter />

      {/* Floating CTA — aparece ao rolar */}
      <FloatingCTA />
    </main>
  );
}
